import { inject, observer } from "mobx-react";
import React from "react";
import Guide from "./Guide";

@inject("workAreaStore") @observer
class GuideWrapper extends React.Component {
  render() {
    const { workAreaStore, pageHeight, pageWidth, pageIndex } = this.props;

    let guides = workAreaStore.getPageGuidelines(pageIndex);
    const zoom = workAreaStore.zoom / 100
    return (
      <div
        style={{
          position: "absolute",
          width: pageWidth,
          height: pageHeight,
          pointerEvents: "none",
        }}
      >
        {guides && guides.x
          ? guides.x
              .filter((f) => f >= 0)
              .map((m, i) => (
                <Guide
                  x={m}
                  pageHeight={pageHeight}
                  key={`x-${i}`}
                  index={`x-${i}`}
                  zoom={zoom}
                />
              ))
          : ""}
        {guides && guides.y
          ? guides.y
              .filter((f) => f >= 0)
              .map((m, i) => (
                <Guide
                  y={m}
                  pageWidth={pageWidth}
                  key={`y-${i}`}
                  index={`y-${i}`}
                  zoom={zoom}
                />
              ))
          : ""}
      </div>
    );
  }
}

export default GuideWrapper;
